export default __webpack_public_path__ + "static/media/html.2ee7f341.png";